import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    BACK_TO_LOGIN,
    GET_ISSUING_REPORT,
    GET_ISSUING_REPORT_FAILED,
    GET_ISSUING_REPORT_SUCCESS,
    DOWNLOAD_SUCCESS,
    GET_MEMBER_BALANCE_REPORT,
    GET_MEMBER_BALANCE_REPORT_FAILED,
    GET_MEMBER_BALANCE_REPORT_SUCCESS,
    GET_POINT_TRANSACTION_REPORT,
    GET_POINT_TRANSACTION_REPORT_FAILED,
    GET_POINT_TRANSACTION_REPORT_SUCCESS,
    GET_REDEEM_REPORT,
    GET_REDEEM_REPORT_FAILED,
    GET_REDEEM_REPORT_SUCCESS,
    GET_REFERRAL_REPORT,
    GET_REFERRAL_REPORT_FAILED,
    GET_REFERRAL_REPORT_SUCCESS,
    GET_VOUCHER_BALANCE_REPORT,
    GET_VOUCHER_BALANCE_REPORT_FAILED,
    GET_VOUCHER_BALANCE_REPORT_SUCCESS,
    GET_POINT_TRANSFER_REPORT,
    GET_POINT_TRANSFER_REPORT_FAILED,
    GET_POINT_TRANSFER_REPORT_SUCCESS,
    GET_PARTNER_REPORT,
    GET_PARTNER_REPORT_SUCCESS,
    GET_PARTNER_REPORT_FAILED,
    GET_POINTS_TRANSACTION_HISTORY_REPORT,
    GET_POINTS_TRANSACTION_HISTORY_REPORT_SUCCESS,
    GET_POINTS_TRANSACTION_HISTORY_REPORT_FAILED,
    GET_POINTS_VOUCHER_REDEMPTION_1_REPORT,
    GET_POINTS_VOUCHER_REDEMPTION_1_REPORT_SUCCESS,
    GET_POINTS_VOUCHER_REDEMPTION_1_REPORT_FAILED,
    GET_POINTS_VOUCHER_REDEMPTION_2_REPORT,
    GET_POINTS_VOUCHER_REDEMPTION_2_REPORT_SUCCESS,
    GET_POINTS_VOUCHER_REDEMPTION_2_REPORT_FAILED,
    MEMBER_DELINQUENCY_REPORT,
    MEMBER_DELINQUENCY_REPORT_SUCCESS,
    MEMBER_DELINQUENCY_REPORT_FAILED,
    GET_OWN_VOUCHER_REPORT,
    GET_OWN_VOUCHER_REPORT_SUCCESS,
    GET_OWN_VOUCHER_REPORT_FAILED,
    GET_PRODUCTCC_REPORT_SUCCESS,
    GET_PRODUCTCC_REPORT_FAILED,
    GET_PRODUCTCC_REPORT,
} from "../../constants/ActionTypes";
import {
    issuingReportApi,
    merchantGroupSearchApi,
    memberBalanceApi,
    pointTransactionApi,
    redeemReportApi,
    referralReportApi,
    voucherBalanceApi,
    pointTransferApi,
    reportPartnerApi,
    pointsTransactionHistoryReportApi,
    pointsVoucherRedemption1ReportApi,
    pointsVoucherRedemption2ReportApi,
    memberDelinquencyApi,
    ownVoucherApi,
    reportCCApi,
} from "../api/Report";
import { apiHandler } from "./handler";

function* fetchIssuingReport({ payload }) {
    const { ok, data, message } = yield* apiHandler(issuingReportApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_ISSUING_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_ISSUING_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchRedeemReport({ payload }) {
    const { ok, data, message } = yield* apiHandler(redeemReportApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_REDEEM_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_REDEEM_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchMemberBalanceReport({ payload }) {
    const { ok, data, message } = yield* apiHandler(memberBalanceApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_MEMBER_BALANCE_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_MEMBER_BALANCE_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchVoucherBalanceReport({ payload }) {
    const { ok, data, message } = yield* apiHandler(voucherBalanceApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_VOUCHER_BALANCE_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_VOUCHER_BALANCE_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchReferralReport({ payload }) {
    const { ok, data, message } = yield* apiHandler(referralReportApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_REFERRAL_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_REFERRAL_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchPointTransaction({ payload }) {
    const { ok, data, message } = yield* apiHandler(pointTransactionApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_POINT_TRANSACTION_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_POINT_TRANSACTION_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchPointTransfer({ payload }) {
    const { ok, data, message } = yield* apiHandler(pointTransferApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_POINT_TRANSFER_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_POINT_TRANSFER_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchReportPartner({ payload }) {
    const { ok, data, message } = yield* apiHandler(reportPartnerApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_PARTNER_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_PARTNER_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchPointsTransactionHistoryReport({ payload }) {
    const { ok, data, message } = yield* apiHandler(pointsTransactionHistoryReportApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_POINTS_TRANSACTION_HISTORY_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_POINTS_TRANSACTION_HISTORY_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchPointsVoucherRedemption1Report({ payload }) {
    const { ok, data, message } = yield* apiHandler(pointsVoucherRedemption1ReportApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_POINTS_VOUCHER_REDEMPTION_1_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_POINTS_VOUCHER_REDEMPTION_1_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchPointsVoucherRedemption2Report({ payload }) {
    const { ok, data, message } = yield* apiHandler(pointsVoucherRedemption2ReportApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_POINTS_VOUCHER_REDEMPTION_2_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_POINTS_VOUCHER_REDEMPTION_2_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchOwnVoucherReport({ payload }) {
    const { ok, data, message } = yield* apiHandler(ownVoucherApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_OWN_VOUCHER_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_OWN_VOUCHER_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchMemberDelinquencyReport({ payload }) {
    const { ok, data, message } = yield* apiHandler(memberDelinquencyApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: MEMBER_DELINQUENCY_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: MEMBER_DELINQUENCY_REPORT_FAILED,
            payload: message
        });
    }
}

function* fetchProductCCReport({ payload }) {
    const { ok, data, message } = yield* apiHandler(reportCCApi, payload);

    if (ok) {
        if (data && payload.isDownload) {
            yield put({ type: DOWNLOAD_SUCCESS, payload: data });
        }

        yield put({
            type: GET_PRODUCTCC_REPORT_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_PRODUCTCC_REPORT_FAILED,
            payload: message
        });
    }
}

export function* getIssuingData() {
    yield takeEvery(GET_ISSUING_REPORT, fetchIssuingReport);
}

export function* getRedeemData() {
    yield takeEvery(GET_REDEEM_REPORT, fetchRedeemReport);
}

export function* getMemberBalanceData() {
    yield takeEvery(GET_MEMBER_BALANCE_REPORT, fetchMemberBalanceReport);
}

export function* getVoucherBalanceData() {
    yield takeEvery(GET_VOUCHER_BALANCE_REPORT, fetchVoucherBalanceReport);
}

export function* getReferralMemberData() {
    yield takeEvery(GET_REFERRAL_REPORT, fetchReferralReport);
}

export function* getPointTransactionData() {
    yield takeEvery(GET_POINT_TRANSACTION_REPORT, fetchPointTransaction);
}

export function* getPointTransferData() {
    yield takeEvery(GET_POINT_TRANSFER_REPORT, fetchPointTransfer);
}

export function* getPartnerData() {
    yield takeEvery(GET_PARTNER_REPORT, fetchReportPartner);
}

export function* getPointTransactionHistoryData() {
    yield takeEvery(GET_POINTS_TRANSACTION_HISTORY_REPORT, fetchPointsTransactionHistoryReport);
}

export function* getPointVoucherRedemption1Data() {
    yield takeEvery(GET_POINTS_VOUCHER_REDEMPTION_1_REPORT, fetchPointsVoucherRedemption1Report);
}

export function* getPointVoucherRedemption2Data() {
    yield takeEvery(GET_POINTS_VOUCHER_REDEMPTION_2_REPORT, fetchPointsVoucherRedemption2Report);
}

export function* getMemberDelinquencyData() {
  yield takeEvery(MEMBER_DELINQUENCY_REPORT, fetchMemberDelinquencyReport);
}

export function* getProductCCData() {
  yield takeEvery(GET_PRODUCTCC_REPORT, fetchProductCCReport);
}

export function* getOwnVoucherData() {
  yield takeEvery(GET_OWN_VOUCHER_REPORT, fetchOwnVoucherReport);
}

// yield all
export default function* rootSaga() {
    yield all([
        fork(getIssuingData),
        fork(getRedeemData),
        fork(getMemberBalanceData),
        fork(getVoucherBalanceData),
        fork(getReferralMemberData),
        fork(getPointTransactionData),
        fork(getPointTransferData),
        fork(getPartnerData),
        fork(getPointTransactionHistoryData),
        fork(getPointVoucherRedemption1Data),
        fork(getPointVoucherRedemption2Data),
        fork(getMemberDelinquencyData),
        fork(getOwnVoucherData),
        fork(getProductCCData),
    ]);
}
